import { createFileRoute } from "@tanstack/react-router";

import { BlogCategoryPage, categoryHead } from "../components/blog/BlogCategoryPage";

export const Route = createFileRoute("/blog/ecommerce")({
  head: () => categoryHead("ecommerce", 1),
  component: CategoryRoute,
});

function CategoryRoute() {
  return <BlogCategoryPage categoryKey="ecommerce" page={1} />;
}
